export default "__VITE_ASSET__d38b6775__"